import request from '@/utils/request';

/**
 * 用户相关 API
 */
export const userApi = {
  // 获取用户信息
  // @param originalUserId 可选，如果提供则使用此ID获取用户信息（用于子账号获取自己的信息）
  getUserInfo(originalUserId = null) {
    const config = {};
    // 如果提供了原始用户ID，手动设置 x-ur-id，绕过拦截器的自动处理
    // 这样确保子账号可以获取自己的信息，而不是父账号的信息
    if (originalUserId != null && originalUserId > 0) {
      config.headers = {
        'x-ur-id': String(originalUserId)
      };
    }
    return request.get('/user/info', config);
  },

  // 更新用户信息
  updateUser(userData) {
    return request.post('/user/info/update', userData);
  },

  // 验证当前密码
  verifyPassword(currentPassword) {
    return request.post('/user/password/verify', { currentPassword });
  },

  // 验证邮箱验证码（用于修改密码）
  verifyEmailCode(email, code) {
    return request.post('/user/password/verify-code', { email, code });
  },

  // 更新密码
  updatePassword(passwordData) {
    return request.post('/user/password/update', passwordData);
  },

  // 获取设备列表
  getDevices() {
    return request.get('/user/devices');
  },

  // 获取省份列表
  getProvinces() {
    return request.get('/user/address/provinces');
  },

  // 根据省份获取区县列表 (第二级)
  getDistricts(province) {
    return request.get('/user/address/districts', { params: { province } });
  },

  // 根据区县获取城市列表 (第三级)
  getCities(district) {
    return request.get('/user/address/cities', { params: { district } });
  },

  // 根据城市ID获取地址信息
  getAddressInfo(ctyId) {
    return request.get('/user/address/info', { params: { ctyId } });
  },

  // 获取父账号信息（用于子账号查看父账号信息）
  getParentAccount(originalUserId = null) {
    const config = {};
    // 如果提供了原始用户ID，手动设置 x-ur-id，确保查询的是当前用户的信息
    if (originalUserId != null && originalUserId > 0) {
      config.headers = {
        'x-ur-id': String(originalUserId)
      };
    }
    return request.get('/user/parent', config);
  }
};